import React from 'react';

import type { Nullable } from '@clearverify/types';

import { IntegrationOrderBy, IntegrationWhere, useIntegrationsListQuery } from 'src/api';
import { PaginationQueryVariables } from 'src/hooks/common';

export const useIntegrations = (
  filter?: IntegrationWhere,
  sort?: Nullable<IntegrationOrderBy>,
  paginationVariables?: PaginationQueryVariables,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = useIntegrationsListQuery({
    variables: {
      filter,
      orderBy: sort,
      ...paginationVariables,
    },
    notifyOnNetworkStatusChange,
  });

  const integrationsList = React.useMemo(() => {
    return data?.integrationList ?? [];
  }, [data?.integrationList]);

  const integrationsCount = React.useMemo(() => {
    return data?.integrationCount || 0;
  }, [data?.integrationCount]);

  return {
    integrationsList,
    integrationsCount,
    integrationsLoading: loading,
    refetch,
  };
};
